var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.378 5.58 9 9.412l6.578-3.81M9 16.207V9.405",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.448 1.86 3.443 4.08c-.908.502-1.65 1.762-1.65 2.797v4.238c0 1.035.742 2.295 1.65 2.797l4.005 2.228c.855.473 2.257.473 3.112 0l4.005-2.228c.908-.502 1.65-1.762 1.65-2.797V6.877c0-1.035-.742-2.295-1.65-2.797L10.56 1.852c-.862-.472-2.257-.472-3.112.008Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDelivery;